import { DeclarationReadinessProgress } from '@/v2/components/product-compliance-briefing/DeclarationReadinessProgress'
import type { LvdProductComplianceFileDeclarationOfConformityRequirement } from '@/v2/lib/lvdProductComplianceFileDeclarationOfConformityRequirements'

type LvdDeclarationReadinessProgressProps = {
  requirements: LvdProductComplianceFileDeclarationOfConformityRequirement[]
  generateReady: boolean
}

export function LvdDeclarationReadinessProgress({
  requirements,
  generateReady,
}: LvdDeclarationReadinessProgressProps) {
  return (
    <DeclarationReadinessProgress
      requirements={requirements}
      generateReady={generateReady}
      labelKey='v2.pages.products.detail.lvdBriefing.declarationReadiness.label'
      readyHintKey='v2.pages.products.detail.lvdBriefing.declarationReadiness.readyHint'
    />
  )
}
